export function download({
  filename,
  mimeType,
  data,
}: {
  filename: string
  mimeType: string
  data: ArrayBuffer
}) {
  const element = document.createElement('a')
  element.setAttribute(
    'href',
    window.URL.createObjectURL(
      new Blob([new Uint8Array(data, 0, data.byteLength)], { type: mimeType })
    )
  )
  element.setAttribute('download', filename)

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}
